import { NavLink } from 'react-router-dom'
import { jobsOnly, paymentsOnly, useSession } from '../../session'

// Tabs across the top of every Sales list page, after PropertyBuk's Finance
// tabs. They replace the old hub of cards and each page's Back button.
const TABS = [
  { to: '/sales', label: 'Summary', end: true },
  { to: '/sales/list', label: 'Sales', module: 'pos' },
  { to: '/sales/quotes', label: 'Quotes', module: 'invoices|jobs', docs: true },
  { to: '/sales/customer-invoices', label: 'Invoices', module: 'invoices|jobs', docs: true },
  { to: '/sales/customer-payments', label: 'Payments', module: 'invoices|jobs|pos' },
  { to: '/sales/refund-lookup', label: 'Refunds', module: 'pos' },
]

export default function SalesTabs() {
  const { has, modules } = useSession()
  // With Jobs but not Invoices, quotes and invoices are on each job's page;
  // with no POS either, payments are all that's left (Summary would repeat them).
  const tabs = TABS.filter((t) => (!t.module || has(t.module)) && !(t.docs && jobsOnly(modules))
    && !(paymentsOnly(modules) && t.to === '/sales'))
  return (
    <nav className="section-tabs" aria-label="Sales">
      {tabs.map(({ to, label, end }) => (
        <NavLink key={to} to={to} end={end}>{label}</NavLink>
      ))}
    </nav>
  )
}
